module.exports = __webpack_public_path__ + "static/media/3S.9638bf9f.png";